const aboutUs = [
  {
    id: 1,
    image: {
      img: './profile-images/niro.jpg',
      alt: "Niro's profile picture",
    },
    name: 'Niro Sarva',
    github: 'https://github.com/NiroSarva',
    linkedin: 'https://www.linkedin.com/in/niro-sarva-73a498161/',
  },
  {
    id: 2,
    image: {
      img: './profile-images/sandra.jpg',
      alt: "Sandra's profile picture",
    },
    name: 'Sandra Skolarczyk',
    github:
      ' https://github.com/sandiskolarczyk',
    linkedin: 'https://www.linkedin.com/in/sandraskolarczyk/',
  },
  {
    id: 3,
    image: {
      img: './profile-images/alex.jpg',
      alt: "Alex's profile picture",
    },
    name: 'Alex Mulgrew',
    github: 'https://github.com/apmcoding',
    linkedin: 'https://www.linkedin.com/alexmulgrew',
  },
  {
    id: 4,
    image: {
      img: "./profile-images/luna.png",
      alt: "Luna's profile picture",
    },
    name: 'Luna Yu',
    github: 'https://github.com/lunay-y',
    linkedin: 'https://www.linkedin.com/in/yuanlunayu/',
  },
  {
    id: 5,
    image: {
      img: './profile-images/diego.jpg',
      alt: "Diego's profile picture",
    },
    name: 'Diego Russo',
    github: 'https://github.com/DEGRUSSECU1',
    linkedin: 'https://www.linkedin.com/in/diego-russo-38989b133/',
  },
  {
    id: 6,
    image: {
      img: './profile-images/MaxMullerProfile.jpg',
      alt: "Max's profile picture",
    },
    name: 'Max Muller',
    github: 'https://github.com/mmuller2',
    linkedin: 'https://www.linkedin.com/in/max-muller-44a372178',
  },
];

export default aboutUs;
